import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./StudentCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import StudentInformations from "./StudentInformations";
import AddressInformations from "./AddressInformations";
import StudyInformations from "./StudyInformations";
import OtherInformations from "./OtherInformations";
import LegalGuardianInformations from "./LegalGuardianInformations";
import AddressLegalGuardianInformations from "./AddressLegalGuardianInformations";

// Services
import { createStudent } from "../../services/createStudent.service";
import { showSuccess, showError } from "../../services/toast.service";

const StudentCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [studentData, setStudentData] = useState({});
  const [isMinor, setIsMinor] = useState(false);

  const handleStudentChange = (e) => {
    const { name, value } = e.target;
    setStudentData((prev) => ({ ...prev, [name]: value }));

    if (name === "birth_date") {
      if (value) {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        setIsMinor(age < 18);
      } else {
        setIsMinor(false);
      }
    }
  };

  const handleSwitchChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    setStudentData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await createStudent(studentData);
      showSuccess("Élève créé avec succès!");
      navigate("/admin/students/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer l'élève: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/students/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <StudentInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
            />
            <AddressInformations
              student={studentData}
              onStudentChange={handleStudentChange}
            />
            {isMinor && (
              <>
                <LegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                  onDropdownChange={handleDropdownChange}
                />
                <AddressLegalGuardianInformations
                  student={studentData}
                  onStudentChange={handleStudentChange}
                />
              </>
            )}
            <OtherInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onSwitchChange={handleSwitchChange}
              onDropdownChange={handleDropdownChange}
            />
            <StudyInformations
              student={studentData}
              onStudentChange={handleStudentChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
              loading={loading}
            />
    
          </form>
        </div>
      </div>
    </>
  );
};

export default StudentCreate;
